<template lang='pug'>
  v-container(pa-0='')
    v-snackbar(v-model="snackbar" color="red" top)
      | El archivo subido no es una imagen
      template(v-slot:action="{ attrs }")
        v-btn(color="white" text="" v-bind="attrs" @click="snackbar = false")
          | Cerrar
    .xs12(class="inputGroupClass")
      v-row.align-self-center
        v-col(cols="12").align-self-center
          v-row.align-self-center
            input.d-none(ref="file" type="file" @change="handleImageUpload" accept="image/*")
            v-card.mx-auto.mt-0.d-inline-flex.v-card--account(:class="model.pictures.imageInput1 ? 'success--text' : 'grey--text'" outlined="" height="106" width="106" @click="$refs.file.click()")
              v-img(v-if="model.pictures.imageInput1" contain max-height='150px' name='image', :src='model.pictures.imageInput1')
              v-icon.mx-auto(v-if="!model.pictures.imageInput1" size="96")
                | mdi-file-image-outline
            input(type='file', style='display: none', ref='imageInput1', @change="handleImageUpload" accept="image/*")
          v-row.text-center.mt-3
            v-col(cols="12").text-center
              v-btn.picker-btn.align-self-center(width='150px' small rounded color='#00b6bd' @click="pickFile('imageInput1')") Cambiar imagen
    v-layout
      v-flex.column()
        v-flex
          div(cols='12')
            v-text-field( label='Nombre de la Subcategoria' :rules="[rules.nameRules]"  counter="100"  type="text", v-model='model.name')
    v-btn(@click="cancel()") Cancelar
    v-btn( v-if ='hasDelete' color='red', @click='deleteCategory') Eliminar
    v-btn(color='#008e95', @click='save' :disabled='!model.name || model.name.length > 100' :loading='categoryLoading')
      | GUARDAR

</template>
<script>
    // import Preview from './Preview';
  import * as firebase from 'firebase'
  import imageCompression from 'browser-image-compression'
  export default {
    components: {
      // Preview: Preview,

    },
    props: {
      model: Object,
      field: Object,
      context: String,
      hasDelete: Boolean,
      onSave: {
        type: Function,
        required: true,
      },
      onDelete: {
        type: Function,
        required: true,

      },
    },
    data () {
      return {
        rules: {
          nameRules: value => {
            return (!!value && value.length > 0 && value.length < 101) || 'Nombre de la subcategoria debe estar entre 0 y Maximo 100 caracteres'
          },
        },
        valueType: '',
        slider: 10,
        imageRef: '',
        e1: 0,
        show: false,
        isMobile: false,
        imageLoading: false,
        audioLoading: false,
        toggle_exclusive: 2,
        snackbar: false,
      }
    },
    computed: {

      user () {
        return this.$store.state.users.user
      },
      sliderValue () {
        return this.slider
      },
      loading () {
        return this.$store.getters.getLoading
      },
      categoryLoading () {
        return this.$store.getters['categories/isLoading']
      },

    },
    mounted () {
      this.onResize()
    },
    methods: {
      cancel () {
        this.$emit('cancel')
      },
      save () {
        this.$store.dispatch('categories/categoryLoading').then(() => {
          this.onSave()
          this.$forceUpdate()
        })
      },
      deleteCategory () {
        this.onDelete()
        this.$forceUpdate()
      },
      pickFile (ref) {
        this.$refs[ref].click()
        this.imageRef = ref
      },
      onAudioPicked (event) {
        const vm = this
        const files = event.target.files

        const filename = files[0].name

        if (filename.lastIndexOf('.') <= 0) {
          return alert('Agrega un archivo valido')
        }
        const fileReader = new FileReader()
        fileReader.addEventListener('loadstart', () => {
          vm.audioLoading = true
        })
        fileReader.addEventListener('loadend', function () {
          vm.audioLoading = false
          // console.log('acabo de subir el archivo de audio')
          vm.setAudio(fileReader.result)
          // console.log(fileReader.result)
        })
        fileReader.readAsDataURL(files[0])
      },
      onImagePicked (event) {
        const vm = this
        const storageRef = firebase.storage().ref()
        let userId
        if (vm.user.adminUid) {
          userId = vm.user.adminUid
        } else {
          userId = vm.user.uid
        }
        vm.model.id = vm.model.id ? vm.model.id : firebase.database().ref().child(`users/${userId}/categories`).push().key
        const metadata = {
          contentType: event.target.files[0].type,

          customMetadata: {
            targetType: event.target.files[0].type,
            targetId: vm.model.id,
            targetName: vm.model.name,
          },
        }
        // Push to child path.
        // [START oncomplete]
        storageRef.child(`users/${userId}/categories/pictures/${vm.model.id}/imageInput1`).put(event.target.files[0], metadata).then(function (snapshot) {
          snapshot.ref.getDownloadURL().then(function (url) {
            vm.model.pictures.imageInput1 = url
          })
        }).catch(function (error) {
          console.error('Upload failed:', error)
        })
      },
      uploadToServer (file) {
        const vm = this
        const storageRef = firebase.storage().ref()
        let userId
        if (vm.user.adminUid) {
          userId = vm.user.adminUid
        } else {
          userId = vm.user.uid
        }
        vm.model.id = vm.model.id ? vm.model.id : firebase.database().ref().child(`users/${userId}/categories`).push().key
        const metadata = {
          contentType: file.type,

          customMetadata: {
            targetType: file.type,
            targetId: vm.model.id,
            targetName: vm.model.name,
          },
        }
        // Push to child path.
        // [START oncomplete]
        storageRef.child(`users/${userId}/categories/pictures/${vm.model.id}/imageInput1`).put(file, metadata).then(function (snapshot) {
          snapshot.ref.getDownloadURL().then(function (url) {
            // console.log(url)
            vm.model.pictures.imageInput1 = url
          })
        }).catch(function (error) {
          console.error('Upload failed:', error)
        })
      },
      async handleImageUpload (event) {
        const vm = this
        const imageFile = event.target.files[0]
        if (imageFile.type.includes('image')) {
          // console.log('originalFile instanceof Blob', imageFile instanceof Blob) // true
          // console.log(`originalFile size ${imageFile.size / 1024 / 1024} MB`)

          const options = {
            maxSizeMB: 0.020,
            maxWidthOrHeight: 120,
            useWebWorker: true,
            maxIteration: 15,
          }
          try {
            const compressedFile = await imageCompression(imageFile, options)
            // console.log('compressedFile instanceof Blob', compressedFile instanceof Blob) // true
            // console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`) // smaller than maxSizeMB
            if (imageFile.size > compressedFile.size) {
              // console.log('compressed is smaller')
              await vm.uploadToServer(compressedFile)
            } else {
              // console.log('original is smaller')
              await vm.uploadToServer(imageFile)
            } // if original is smaller
          } catch (error) {
            // console.log(error)
          }
        } else {
          vm.snackbar = true
        }
      },
      setAudio (audio) {
        this.model.audio = audio
        this.$forceUpdate()
      },
      setImage (ref, image) {
        // console.log(ref)
        this.model.pictures[ref] = image
        // console.log(this.model)
        this.$forceUpdate()
      },
      onResize () {
        this.isMobile = window.innerWidth < 1024
      },
    },

  }
</script>
<style scoped lang="scss">
    $break-large: 1200px;
    $primary-color: #c29f52;
    .grid-picker{
        text-align: center;
        min-width: 100%;
        display: grid;
        position: relative;
        flex: 1;
        width: 100%;
        grid-template-areas:

                'picture picture '
                'title title '
                'button button';
        @media screen and (min-width: $break-large) {
            grid-template-areas:

                    'title picture picture '
                    'title picture picture '
                    'button button button';
            .image-slot{
                min-width: 400px;
                height: 250px;
                overflow: hidden;
            }
        }

        grid-gap: 10px;

        padding: 10px;
        .picker-btn{

            grid-area: button;
            flex: 1;
            height: 50px;
        }
        .image-slot{
            margin-left: auto;
            margin-right: auto;
            width: 100%;
            display: flex;
            grid-area: picture;
            max-width: 350px;
            max-height: 250px;
            background: #9e9e9e;
            align-items:center;
            justify-content: center;

        }
    }

    .phone-screen{

        background: url("/img/phone.png");
        display:flex;
        flex-direction: column;
        border-radius: 50px;
        border: 1px solid black;

        min-width: 379px;
        min-height: 736px;
        background-size:  379px 736px;
        background-repeat: no-repeat;
        margin:auto;
        overflow: hidden;
        &__content{

            overflow-y: auto;
            max-width: 382px;
            max-height: 595px;
            margin: auto !important;
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            padding: 0 15px;
        }
    }
    .main-carousel{
        position: relative;
        &__overlay{
            position: absolute;
            bottom:0;
            left:0;
            right:0;
            height: 45px;
            width: 100%;
            margin: auto !important;
            background:rgba(#000,0.5);
            color: #fff;
            text-align: center;

        }
    }
    .property-values{
        border: 1px solid #c29f52;
        border-radius: 30px;
        height: auto;
        padding: 0 10px;
        h3{
            color:#c29f52;
            font-weight: 900;

        }
        .price-tooltip{
            color:#c29f52;
            font-weight: bold;
            margin:auto;
            margin-top:-10px;
            max-width: 100px;
            border: 1px solid #c29f52;
            border-radius: 15px;
            border-top-right-radius: 0;
            border-top-left-radius: 0;
            border-top: none;
        }
    }
    .numPayments{
        background: white !important;
        border: 1px solid #777;
        border-radius: 25px;
        width:auto;
        max-width: fit-content;

        &__button{
            color:#000 !important;
            border-radius: 40px;
        }
    }
    .v-input--slider{
        margin-top:0;
    }
    .v-tabs__container{
        max-width: 100%;
        overflow-x: auto;

    }
    .property-sections{
        span,b{
            font-size: 15px !important;
        }

        .v-tab{
            color: black !important;
        }
    }
    .property-toolbar{

    }
</style>
